import React from "react";

import {FormControl} from "@material-ui/core";

import Switch from "../../../../../components/AssetModal/components/Switch";
import LabelFormElement from "../../../../RiskProfiling/components/StepContent/components/formElement/LabelFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {DisabledReasonTooltip} from "../../../../../components/Tooltip";
import WarningTooltip from "../../../../../components/WarningTooltip";

export const ON_LABEL = "Ja";
export const OFF_LABEL = "Nein";

const Toggle = ({label, value=false, onChange, disabled=false, disableReason, info}) => {
  return (
    <DisabledReasonTooltip title={disabled && disableReason} width={600}>
      <div>
        <FormControl disabled={disabled}>
          <LabelFormElement
            label={<>{label}{!!info && <WarningTooltip title={info} width={600} />}</>}
            customClasses={newDesignInputCustomClasses}
            style={{paddingBottom: 5}}
          >
            <Switch
              value={value}
              handleValueChanged={onChange}
              onLabel={ON_LABEL}
              offLabel={OFF_LABEL}
              disabled={disabled}
            />
          </LabelFormElement>
        </FormControl>
      </div>
    </DisabledReasonTooltip>
  )
};

export default Toggle;